export default __webpack_public_path__ + "static/media/bwMan.ce36f4df.jpg";